import { lazy } from "react";
import { lazyWithPreload } from "../helpers/lazyWithPreload";

// Route-level code splitting: a public menu visitor only downloads the menu
// chunk, the landing page only the home chunk, and antd-based private
// features (auth + admin panel) load through AdminAuthShell.

// The home pages (/, /es, /uk) are pre-rendered by react-snap, so HomeView is
// preloadable — src/index.js preloads it before hydrating.
export const HomeView = lazyWithPreload(() => import("./home-view/HomeView"));
export const TermsOfService = lazy(
  () => import("./home-view/pages/TermsOfService"),
);
export const Menu = lazy(() => import("./menu/Menu"));
export const AdminAuthShell = lazy(() => import("./AdminAuthShell"));
